import { FetcherResponse } from '../../../../../../components/Hooks/useList.types';
import { Message } from '../../../../contexts/chatSocket/reducer/chatSocketReducer.types';
import { MessageType } from '../../../../types/chat.types';

export enum ChatMessageViewEnum {
  CHAT_MESSAGES = 'chatMessages',
  EDIT_CHAT = 'editChat',
}

export type ChatMessageAcceptedMessageTypesToFilter = MessageType.IMAGE_OR_VIDEO | MessageType.FILE;

export type ChatMessagesState = {
  view: ChatMessageViewEnum;
  page: number;
  hasMore: boolean;
  isLoading: boolean;
  totalItems: number;
  messages: Message[];
  firstItemIndex: number;
  filterMessagesOfType?: ChatMessageAcceptedMessageTypesToFilter;
  error?: string;
};

export type ChatMessagesActions =
  | {
      type: 'FETCHING_MORE';
    }
  | {
      type: 'FETCH_MESSAGES_RESULT';
      payload: FetcherResponse<Message>;
    }
  | {
      type: 'INCREMENT_NEW_WS_MESSAGE';
      payload: { message: Message };
    }
  | {
      type: 'REMOVE_WS_MESSAGE';
      payload: RemoveWsMessagePayload;
    }
  | {
      type: 'GO_TO_EDIT_CHAT';
    }
  | {
      type: 'SET_MESSAGES_FILTER_BY';
      payload: SetMessagesFilterByPayload;
    }
  | {
      type: 'GO_TO_CHAT';
    };

export interface RemoveWsMessagePayload {
  messageTemporaryId: string;
}

export interface SetMessagesFilterByPayload {
  filterBy?: ChatMessageAcceptedMessageTypesToFilter;
}
